/**
 * Created by pmnia on 7/4/15.
 */
require('./login.module.js');
require('./login.controller.js');
require('./obt-Login.directive.js');
require('./updateSectionDirective/updateSectionDirective.js');
require('./updateSectionForms/updateSectionCtrl.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/login/login.require.js
 ** module id = 225
 ** module chunks = 0
 **/